// LORA Geschenk-Belohnung
// Fuegt das Gratis-Geschenk per Klick in den Warenkorb. Der zugehoerige
// automatische BxGy-Rabatt (ab Bestellwert-Schwelle) rabattiert es auf 0 EUR.
// Bewusst KEIN Auto-Add: der Kunde stimmt aktiv zu (transparent, kein Remove-Loop).
//
// Zusaetzlich: Auto-Remove-Waechter. Faellt der qualifizierende Pre-Discount-Subtotal
// (ohne den Geschenk-Wert selbst) unter die Schwelle, wird die mit _free_gift markierte
// Geschenk-Line wieder entfernt, damit kein stiller 0 -> Vollpreis-Sprung entsteht.
//
// Refresh-Muster identisch zu buy-the-look.js: Sections an /cart/* mitgeben, danach
// CartAddEvent/CartUpdateEvent dispatchen, damit Horizon den Cart-Drawer neu rendert.

import { CartAddEvent, CartUpdateEvent, ThemeEvents } from '@theme/events';

const SOURCE = 'lora-gift-reward';

/** IDs der Cart-Sections sammeln, damit /cart/* sie serverseitig mitrendert. */
function collectCartSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((c) => {
    if (c instanceof HTMLElement && c.dataset.sectionId) {
      ids.push(c.dataset.sectionId);
    }
  });
  return ids.join(',');
}

// ── Geschenk per Button hinzufuegen ──────────────────────────────

async function addGift(btn) {
  const variantId = btn.dataset.variantId;
  if (!variantId || btn.dataset.loading === 'true') return;

  btn.dataset.loading = 'true';
  btn.disabled = true;
  const label = btn.querySelector('span');
  const originalLabel = label ? label.textContent : '';
  if (label && btn.dataset.loadingLabel) label.textContent = btn.dataset.loadingLabel;

  try {
    const url = window.Theme?.routes?.cart_add_url || '/cart/add.js';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        // _free_gift markiert die Line fuer den Auto-Remove-Waechter (Underscore =
        // im Cart-UI versteckt; der BxGy-Rabatt rabattiert die Line weiterhin auf 0).
        items: [{ id: Number(variantId), quantity: 1, properties: { _free_gift: '1' } }],
        sections: collectCartSectionIds(),
      }),
    });
    const response = await res.json();

    if (response.status) {
      console.error('[gift-reward] add rejected', response.message);
      if (label) label.textContent = originalLabel;
      btn.disabled = false;
      btn.dataset.loading = 'false';
      return;
    }

    document.dispatchEvent(
      new CartAddEvent(response, SOURCE, {
        source: SOURCE,
        itemCount: 1,
        sections: response.sections,
      })
    );
  } catch (err) {
    console.error('[gift-reward] add failed', err);
    if (label) label.textContent = originalLabel;
    btn.disabled = false;
    btn.dataset.loading = 'false';
  }
}

document.addEventListener('click', (event) => {
  const btn =
    event.target instanceof Element ? event.target.closest('[data-gift-add]') : null;
  if (!btn) return;
  event.preventDefault();
  addGift(btn);
});

// ── Auto-Remove unter Schwelle ───────────────────────────────────

let removingGift = false;

/** Liest Variante + Schwelle aus dem (immer gerenderten) Config-Element der Bar. */
function giftConfig() {
  const el = document.querySelector('[data-gift-config]');
  if (!el) return null;
  const variantId = Number(el.dataset.variantId);
  const threshold = Number(el.dataset.threshold); // in Cent
  if (!variantId || !threshold) return null;
  return { variantId, threshold };
}

async function enforceGiftThreshold() {
  if (removingGift) return;
  const cfg = giftConfig();
  if (!cfg) return;

  let cart;
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    cart = await res.json();
  } catch (e) {
    return;
  }

  const giftLine = (cart.items || []).find(
    (i) => i.properties && i.properties._free_gift === '1' && Number(i.variant_id) === cfg.variantId
  );
  if (!giftLine) return;

  // Qualifizierender Betrag = Pre-Discount-Subtotal OHNE den Geschenk-Wert selbst
  // (entspricht der BxGy-Logik: der "Gets"-Artikel zaehlt nicht in die "Buys"-Schwelle).
  const qualifying = (cart.original_total_price || 0) - (giftLine.original_line_price || 0);
  if (qualifying >= cfg.threshold) return;

  removingGift = true;
  try {
    const url = window.Theme?.routes?.cart_change_url || '/cart/change.js';
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: giftLine.key, quantity: 0, sections: collectCartSectionIds() }),
    });
    const response = await res.json();
    document.dispatchEvent(
      new CartUpdateEvent(response, SOURCE, { source: SOURCE, sections: response.sections })
    );
  } catch (e) {
    console.error('[gift-reward] auto-remove failed', e);
  } finally {
    removingGift = false;
  }
}

// Auf jede Warenkorb-Aenderung pruefen. Der removingGift-Guard + die "kein Gift-Line"-
// Frueh-Rueckkehr verhindern eine Endlosschleife durch das eigene CartUpdateEvent.
document.addEventListener(ThemeEvents.cartUpdate, () => {
  enforceGiftThreshold();
});
